import { render, staticRenderFns } from "./company-contact.vue?vue&type=template&id=603aba70&scoped=true&lang=pug"
import script from "./company-contact.vue?vue&type=script&lang=ts"
export * from "./company-contact.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603aba70",
  null
  
)

export default component.exports